import { render, staticRenderFns } from "./ItemBase.vue?vue&type=template&id=30fe88ec&scoped=true&"
import script from "./ItemBase.vue?vue&type=script&lang=js&"
export * from "./ItemBase.vue?vue&type=script&lang=js&"
import style0 from "./ItemBase.vue?vue&type=style&index=0&id=30fe88ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fe88ec",
  null
  
)

export default component.exports